import {
	createHandlerChainRunner, executeAwaitableHandlerChain, Handler
} from '@insite/client-framework/HandlerCreator';
import { getCatalogPageStateByPath } from '@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors';
import loadCatalogPageByPath from '@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath';

interface Parameter {
    path: string;
}

type HandlerType = Handler<Parameter>;

export const RequestCatalogPageFromApi: HandlerType = async props => {
    const { path } = props.parameter;

    if (path) {
        if (getCatalogPageStateByPath(props.getState(), path).value) return;
        await executeAwaitableHandlerChain(loadCatalogPageByPath, { path }, props);
    }
};

export const chain = [RequestCatalogPageFromApi];

const displayBreadcrumb = createHandlerChainRunner(chain, "DisplayBreadcrumb");
export default displayBreadcrumb;